import React, { useRef, useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { testimonialsData } from '../utils/mockData';

const Testimonials = () => {
  const carouselRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const renderStars = (rating) => {
    return Array(rating).fill(0).map((_, index) => (
      <Star key={index} className="star-icon" fill="currentColor" />
    ));
  };

  const checkScrollPosition = () => {
    if (carouselRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  const scroll = (direction) => {
    if (carouselRef.current) {
      const scrollAmount = 350;
      carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
      setTimeout(checkScrollPosition, 300);
    }
  };

  return (
    <section id="testimonials" className="section-padding">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="section-title">Client Reviews</h2>
          <div className="section-title-underline"></div>
          <p className="section-description">
            Don't just take my word for it - hear from clients who've transformed their lives
          </p>
        </div>

        <div className="testimonial-carousel-wrapper">
          {/* Left Arrow */}
          <button 
            className={`carousel-arrow carousel-arrow-left ${!canScrollLeft ? 'carousel-arrow-disabled' : ''}`}
            onClick={() => scroll('left')}
            disabled={!canScrollLeft}
            aria-label="Previous reviews"
            data-testid="testimonial-prev-btn"
          >
            <ChevronLeft size={24} />
          </button>

          {/* Carousel */}
          <div 
            className="testimonial-carousel"
            ref={carouselRef}
            onScroll={checkScrollPosition}
          >
            {testimonialsData.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-carousel-card">
                <div className="testimonial-rating">
                  {renderStars(testimonial.rating)}
                </div>
                <p className="testimonial-carousel-text">"{testimonial.text}"</p>
                <div className="testimonial-carousel-footer">
                  <span className="testimonial-carousel-name">{testimonial.name}</span>
                  <span className="testimonial-carousel-divider">•</span>
                  <span className="testimonial-carousel-service">{testimonial.service}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Right Arrow */}
          <button 
            className={`carousel-arrow carousel-arrow-right ${!canScrollRight ? 'carousel-arrow-disabled' : ''}`}
            onClick={() => scroll('right')}
            disabled={!canScrollRight}
            aria-label="Next reviews"
            data-testid="testimonial-next-btn"
          >
            <ChevronRight size={24} />
          </button>
        </div>

        {/* Scroll hint for mobile */}
        <p className="testimonial-swipe-hint">Swipe to see more reviews</p>
      </div>
    </section>
  );
};

export default Testimonials;
